import { Box } from "@mui/material";
import { isNil } from "lodash-es";

import { ApiEnumName } from "@/common/services/enum";
import { DamageCostEvaluationDamageCorrectionsDto } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../../Enum/InlineApiEnumValue";
import InfoTile from "../../../Form/Display/InfoTile";

interface Props {
  corrections: Nil<DamageCostEvaluationDamageCorrectionsDto>;
}

export function DamageCostEvaluationDamageCorrectionsOverviewDisplay({ corrections }: Props) {
  return (
    <Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xxs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gridTemplateRows: "auto",
          rowGap: 1,
          columnGap: 1,
        }}
      >
        <InfoTile
          label='Correction status'
          iconOf='status'
          isEmpty={isNil(corrections?.correctionStatus)}
        >
          <InlineApiEnumValue
            type={ApiEnumName.DamageCorrectionStatus}
            value={corrections?.correctionStatus}
            withHelperTooltip
          />
        </InfoTile>

        <InfoTile
          label='Original damages'
          iconOf='damage'
          isEmpty={isNil(corrections?.initialAndOriginalCount)}
        >
          {corrections?.initialAndOriginalCount}
        </InfoTile>

        <InfoTile label='New damages' iconOf='damage' isEmpty={isNil(corrections?.currentCount)}>
          {corrections?.currentCount}
        </InfoTile>

        <InfoTile label='Corrected' iconOf='edit' isEmpty={isNil(corrections?.correctedCount)}>
          {corrections?.correctedCount}
        </InfoTile>

        <InfoTile
          label='Not corrected'
          iconOf='editOff'
          isEmpty={isNil(corrections?.notCorrectedCount)}
        >
          {corrections?.notCorrectedCount}
        </InfoTile>

        <InfoTile label='Added' iconOf='add' isEmpty={isNil(corrections?.addedCount)}>
          {corrections?.addedCount}
        </InfoTile>

        <InfoTile label='Updated' iconOf='edit' isEmpty={isNil(corrections?.updatedCount)}>
          {corrections?.updatedCount}
        </InfoTile>

        <InfoTile label='Removed' iconOf='remove' isEmpty={isNil(corrections?.removedCount)}>
          {corrections?.removedCount}
        </InfoTile>
      </Box>
    </Box>
  );
}
